import { Alignment } from "../../../foundations/alignment.es.js";
import { BorderStyle } from "../../../foundations/border-style.es.js";
import { styled } from "@mui/material";
import { DropzonePhase } from "./dropzone.enum.es.js";
const CustomDropzone = styled("div")(function returnDropzoneStyle({
  theme,
  status
}) {
  return computeDropzoneStyle(theme, status);
});
function computeDropzoneStyle(theme, status) {
  const isSpecialStatus = (status == null ? void 0 : status.phase) === DropzonePhase.Invalid || (status == null ? void 0 : status.phase) === DropzonePhase.Valid;
  const isErrorStatus = (status == null ? void 0 : status.phase) === DropzonePhase.Invalid;
  const isValidStatus = (status == null ? void 0 : status.phase) === DropzonePhase.Valid;
  const isBackgroundTransparent = (status == null ? void 0 : status.phase) === DropzonePhase.Empty;
  let borderColor = theme.palette.primary.main;
  const broderStyle = isSpecialStatus ? BorderStyle["solid"] : BorderStyle["dashed"];
  const defaultBorder = getBorderStyle(broderStyle, borderColor);
  const defaultStyle = {
    border: defaultBorder,
    flex: "1 0 0",
    borderRadius: theme.spacing(2),
    padding: theme.spacing(7),
    textAlign: Alignment.center,
    backgroundColor: isBackgroundTransparent ? "transparent" : theme.palette.background.paper
  };
  if (!isSpecialStatus) {
    return defaultStyle;
  }
  if (isValidStatus) {
    borderColor = theme.palette.success.main;
  } else if (isErrorStatus) {
    borderColor = theme.palette.error.main;
  }
  return {
    ...defaultStyle,
    border: getBorderStyle(broderStyle, borderColor)
  };
}
function getBorderStyle(style, borderColor) {
  return `1px ${style} ${borderColor}`;
}
export {
  CustomDropzone
};
//# sourceMappingURL=custom-dropzone.es.js.map
